import { useSubscription } from '@apollo/client';
import { GET_CONTACT_SUGGESTIONS_COUNT_SUBSCRIPTION } from '@zaplify/graphql';
import { FC } from 'react';
import { PageHeader } from '../../../../components/page-header';

export const SuggestionsPageHeader: FC = () => {
    const { data: contactSuggestionsCount, loading: contactSuggestionsCountLoading } = useSubscription(
        GET_CONTACT_SUGGESTIONS_COUNT_SUBSCRIPTION
    );

    return (
        <PageHeader
            title="Discovery"
            description="Discover contacts inside and outside your network that align with your created playbooks."
            count={contactSuggestionsCount?.ContactSuggestions_aggregate?.aggregate?.count}
            isLoadingCount={contactSuggestionsCountLoading}
        />
    );
};
